export default "__VITE_ASSET__c4279c98__"